var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarbonPolicy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 13.5003C22.5015 12.7493 22.315 12.0098 21.9576 11.3494C21.6001 10.6889 21.083 10.1283 20.4535 9.71888C19.8239 9.30942 19.1019 9.06403 18.3532 9.00509C17.6045 8.94615 16.8529 9.07553 16.167 9.38144C15.4812 9.68734 14.8827 10.16 14.4263 10.7565C13.9699 11.3529 13.67 12.054 13.554 12.796C13.438 13.538 13.5095 14.2973 13.7621 15.0045C14.0147 15.7118 14.4402 16.3446 15 16.8453V22.5003L18 21.0806L21 22.5003V16.8453C21.4715 16.4248 21.8489 15.9095 22.1074 15.3331C22.3659 14.7566 22.4997 14.1321 22.5 13.5003ZM19.5 20.1303L18 19.4201L16.5 20.1303V17.7378C17.4694 18.0879 18.5306 18.0879 19.5 17.7378V20.1303ZM18 16.5003C17.4066 16.5003 16.8266 16.3244 16.3333 15.9947C15.8399 15.6651 15.4554 15.1965 15.2284 14.6484C15.0013 14.1002 14.9419 13.497 15.0576 12.915C15.1734 12.3331 15.4591 11.7985 15.8787 11.379C16.2982 10.9594 16.8328 10.6737 17.4147 10.5579C17.9967 10.4422 18.5999 10.5016 19.148 10.7287C19.6962 10.9557 20.1648 11.3402 20.4944 11.8336C20.824 12.3269 21 12.907 21 13.5003C20.999 14.2956 20.6826 15.0581 20.1202 15.6205C19.5578 16.1829 18.7953 16.4993 18 16.5003Z",
    fill: "black",
    stroke: "#F2F2F2",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 10.5H12V12H6.75V10.5Z",
    fill: "black",
    stroke: "#F2F2F2",
    strokeWidth: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 6H14.25V7.5H6.75V6Z",
    fill: "black",
    stroke: "#F2F2F2",
    strokeWidth: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 22.5C4.1023 22.4996 3.721 22.3414 3.43978 22.0602C3.15856 21.779 3.0004 21.3977 3 21V3C3.0004 2.6023 3.15856 2.221 3.43978 1.93978C3.721 1.65856 4.1023 1.5004 4.5 1.5H16.5C16.8977 1.5004 17.279 1.65856 17.5602 1.93978C17.8414 2.221 17.9996 2.6023 18 3V6H16.5V3H4.5V21H12V22.5H4.5Z",
    fill: "black",
    stroke: "#F2F2F2",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonPolicy);
export default __webpack_public_path__ + "static/media/carbon_policy.c7488aeb42e63c397ebd44e0d7c5af0f.svg";
export { ForwardRef as ReactComponent };